import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiSvgModule } from "@taiga-ui/core";
import { KwikUIMessagesComponent } from "./messages.component";

@NgModule({
  declarations: [KwikUIMessagesComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TuiSvgModule],
  exports: [KwikUIMessagesComponent]
})
export class KwikUIMessagesModule {}
